/**
 * web-auth SDK 유저 프로필 관련 모듈
 */

class InfaceUserProfile {
  constructor({
    uid,
    is_guest,
    local_session_user_id,
    local_session_type,
    local_session_props,
    local_profile_props,
    platform_user_id,
    platform_type,
  }) {
    this.uid = uid || ''
    this.is_guest = is_guest
    this.platform_user_id = platform_user_id || '' // INSIGN에서 제공하는 값으로 사용 권장
    this.platform_type = platform_type || '' // INSIGN에서 제공하는 값으로 사용 권장
    this.local_session_user_id = local_session_user_id || ''
    this.local_session_type = local_session_type || ''
    this.local_session_props = local_session_props || {}
    this.local_profile_props = local_profile_props || {}
  }
}

export default InfaceUserProfile
